
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vioc",
      function () {
        return require("private-next-pages/vioc/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vioc"])
      });
    }
  